let RouterMeta = {
    index:{
        name:"index",
        path:"/"
    },
    notFound:{
        name:"notFound",
        path:"/notFound"
    },
    login:{
        name:"login",
        path:"/login"
    },
    grid:{
        name:"grid",
        path:'/grid/:gridId'
    },
    chart:{
        name:"chart",
        path:'/chart/:chartId'
    },
    customPage:{
        name:"customPage",
        path:'/customPage/:customPageId'
    },
    fullScreenCustomPage:{
        name:"fullScreenCustomPage",
        path:'/fullScreenCustomPage/:customPageId'
    },
    form:{
        name:"form",
        path:'/form/:formId/:contentItemId?/:nodeId?'
    },
    externalForm:{
        name:"externalForm",
        path:'/externalForm/:formId/:contentItemId?/:nodeId?'
    },
    todoTask:{
        name:"todoTask",
        path:'/task/todo'
    },
    ownerTask:{
        name:"ownerTask",
        path:'/task/owner'
    },
    participateTask:{
        name:"participateTask",
        path:'/task/participate'
    },
    cCTask:{
        name:"cCTask",
        path:'/task/cCTask'
    },
    netWorkError:{
        name:"netWorkError",
        path:"/netWorkError"
    },
    unAuthoized:{
        name:"unAuthoized",
        path:"/unAuthoized"
    },
    baseNetWorkError:{
        name:"baseNetWorkError",
        path:"/baseNetWorkError"
    },

    propCustomPage:{
        name:"propCustomPage",
        path:"/propCustomPage"
    },
    propGrid:{
        name:"propGrid",
        path:"/propGrid/:propGridId"
    }
}

export type RouteInfo = {
    human:boolean,
    name:string,
    params:object
}


export type RoutePlayod = {
    routeInfo:RouteInfo, 
    routePath:string
}

export { RouterMeta }